import React, { useState } from "react";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import "./AccountingTable.scss";
import Export from "../../images/export.svg";
import AccountingDetailModal from "./AccountingDetailModal";

function AccountingTableDetails({ selectedData }) {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const data = [{ data: 1, data2: 2 }, { data: 1 }];

  return (
    <>
      <AccountingDetailModal
        open={open}
        handleClose={handleClose}
        selectedData={selectedData}
      />

      <TableHead>
        <TableRow className="detail-header-colour">
          <TableCell align="left" className="">
            <div className="header-cell-content">
              <p className="accounting-detail-headers">Account Type</p>
            </div>
          </TableCell>
          <TableCell align="left" className="accounting-detail-headers">
            <div className="header-cell-content">
              <p className="accounting-detail-headers">Account ID</p>
            </div>
          </TableCell>

          <TableCell align="left" className="accounting-detail-headers">
            <div className="header-cell-content">
              <p className="accounting-detail-headers">Account Name</p>
            </div>
          </TableCell>
          <TableCell align="left" className="accounting-detail-headers">
            <div className="header-cell-content">
              <p className="accounting-detail-headers">Debit</p>
            </div>
          </TableCell>
          <TableCell align="left" className="accounting-detail-headers">
            <div className="header-cell-content">
              <p className="accounting-detail-headers">Credit</p>
            </div>
          </TableCell>
          <TableCell align="left" className="accounting-detail-headers">
            <div className="header-cell-content">
              <p className="accounting-detail-headers"></p>
            </div>
          </TableCell>
          <TableCell align="left" className="accounting-detail-headers">
            <div className="header-cell-content">
              <p className="accounting-detail-headers"></p>
            </div>
          </TableCell>

          <TableCell
            // className="accounting-detail-headers d-flex justify-content-right"
            align="right"
          >
            <div className="header-cell-content">
              <p className="accounting-detail-headers"></p>
            </div>
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {selectedData.map((row, index) => (
          <React.Fragment key={index}>
            <TableRow>
              <TableCell style={{ width: 200 }} align="left">
                <p className="account-detail-rows">
                  {row.vacctstructure.acctsubtypename}
                </p>
              </TableCell>

              <TableCell style={{ width: 200 }} align="left">
                <div className="transaction-table-address-container">
                  <p className="account-detail-rows ">
                    {row.vacctstructure.acctID}
                  </p>
                </div>
              </TableCell>
              <TableCell style={{ width: 200 }} align="left">
                <div className="transaction-table-address-container">
                  <p className="account-detail-rows ">S1 Security</p>
                </div>
              </TableCell>

              <TableCell style={{ width: 200 }} align="left">
                <p className="account-detail-rows ">$100,000</p>
              </TableCell>
              <TableCell style={{ width: 200 }} align="left">
                <p className="account-detail-rows "></p>
              </TableCell>

              <TableCell style={{ width: 200 }} align="left">
                <p className="account-detail-rows "></p>
              </TableCell>
              <TableCell style={{ width: 200 }} align="left">
                <div
                  //   className="d-flex justify-content-end"
                  style={{ cursor: "pointer" }}
                >
                  {/* <p className="account-detail-rows">View</p> */}
                </div>
              </TableCell>
              <TableCell style={{ width: 200 }} align="left">
                <div
                  className="d-flex justify-content-end"
                  style={{ cursor: "pointer" }}
                >
                  <p className="account-detail-rows">
                    <img src={Export} onClick={handleOpen} />
                  </p>
                </div>
              </TableCell>
            </TableRow>
          </React.Fragment>
        ))}
      </TableBody>
    </>
  );
}

export default AccountingTableDetails;
